import { cx } from "classix"
import type { HTMLAttributes } from "react"

import "@fontsource/material-icons/index.css"
import "@fontsource/material-icons-outlined/index.css"

import cssModule from "./index.module.css"

/**
 * Свойства `MaterialIcon`
 */
export interface MaterialIconProps extends HTMLAttributes<HTMLSpanElement> {
	/** имя иконки */
	name: string
	outlined?: boolean,
	size?: number | string
}

/**
 * Иконка от [Google](https://fonts.google.com/icons?icon.style=Filled&icon.set=Material+Icons).
 * @param props
 * @component
 * @category Component
 * @example
 * ```tsx
 * import {MaterialIcon} from "~/shared/ui";
 *
 * function Example() {
 *     return (
 *         <MaterialIcon name="add" />
 *     );
 * }
 * ```
 */
export function MaterialIcon({
								 name,
								 outlined = false,
								 className,
								 size = "1.5rem",
								 style,
								 ...spanProps
							 }: MaterialIconProps) {
	return (
		<span
			style={{ fontSize: typeof size === "number" ? `${size}rem` : size, ...style }}
			className={cx(
				outlined ? cssModule.materialIconsOutlined : cssModule.materialIcons,
				className
			)}
			{...spanProps}
		>
			{name}
		</span>
	)
}
